import { render, staticRenderFns } from "./TripStartStop.vue?vue&type=template&id=3b2f6187"
import script from "./TripStartStop.vue?vue&type=script&lang=js"
export * from "./TripStartStop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports